import { Checkbox, Field } from "components/shared/form";
import policy from "policies";
import React from "react";

const Exploitation = (props) => {
    const { data, onChange, config, roles } = props;
    const renderField = (fieldConfig, i, prefix) => {
        const Component = fieldConfig.isCheckbox ? Checkbox : Field;
        const value = prefix
            ? data[prefix]
                ? data[prefix][fieldConfig.inputProps.name]
                : ""
            : data[fieldConfig.inputProps.name];
        const onFieldChange = ({ name, value }) => {
            if (prefix) {
                const newValue = { ...data[prefix], [name]: value };
                onChange({ name: prefix, value: newValue });
            } else {
                onChange({ name, value });
            }
        };
        return (
            <Component
                key={`${prefix}_${i}`}
                {...fieldConfig}
                i={i}
                value={value}
                onChange={onFieldChange}
                disabled={!policy("user", { user: { roles } }).isAdminWithWriteAccess()}
            />
        );
    };

    return [
        renderField(config.apiKey, 0),
        renderField(config.approvingSettings.considerCurrentLocation, 1, "approvingSettings"),
    ];
};

export default Exploitation;
